module.exports = __webpack_public_path__ + "img/mastercard.b3af8046.png";